/**
 * Created by mac on 2019-10-24
 */

cleverapps.Spine = cc.Node.extend({
    ctor: function (json, atlas) {
        this._super();

        json = json instanceof VirtualJson ? json.resolve() : json;
        this.jsonName = json;

        const bundleName = json instanceof VirtualJson ? json.bundleName : undefined;
        const loaded = cleverapps.bundleLoader.isLoaded(bundleName);

        if (!loaded && bundleName !== "loading_scene" && json && bundleName) {
            const deleteStack = cleverapps.bundleLoader.deleteStack && cleverapps.bundleLoader.deleteStack[bundleName];
            throw new Error(`Json ${json} bundle ${bundleName} not loaded stack${deleteStack}`);
        }

        if (bundleName === undefined && !atlas) {
            throw new Error(`Can't find bundle for json - ${json} in bundles cache `);
        }

        let jsonFile = json;
        let atlasFile = atlas || bundles[bundleName].atlas;

        const atlasLoaded = typeof atlasFile === "string" ? cc.loader.getRes(atlasFile) : atlasFile;
        if (!atlasLoaded) {
            throw new Error(`Atlas ${jsonFile} bundle ${bundleName} not loaded ${loaded}`);
        }

        const cached = cleverapps.Spine.getCachedData(json);
        if (cached) {
            jsonFile = cached.data;
            atlasFile = cached.atlas;
        }

        let spine;
        try {
            spine = this.spine = sp.SkeletonAnimation.createWithJsonFile(jsonFile, atlasFile, json);
        } catch (e) {
            console.error(e);
            if (cleverapps.config.debugMode) {
                const gitData = cleverapps.Spine.getGitPath(json) || {};
                e.message = `${gitData.name}\n${gitData.link}\n${e}`;
            } else {
                e.message = `${json}\n${e}`;
            }
            throw new Error(e.message);
        }
        spine.jsonName = json;

        const data = {
            data: spine._skeletonData,
            atlas: atlasFile
        };
        if (engine === "cocos2d") {
            data.atlas = true;
        }
        cleverapps.Spine.setCachedData(data, json, spine.getSkin && spine.getSkin());

        this.data = cc.loader.getRes(json);
        const skeleton = this.data.skeleton;
        this.setContentSize2(skeleton.width * resolutionScale, skeleton.height * resolutionScale);
        spine.setAlignment(this.width / 2, this.height / 2);
        this.addChild(spine);
        
        const anchorBone = this.getAnchorBone();
        if (anchorBone) {
            const x = (this.width / 2 + anchorBone.x * resolutionScale) / this.width;
            const y = (this.height / 2 + anchorBone.y * resolutionScale) / this.height;
            this.setAnchorPoint(x, y);
        } else {
            this.setAnchorPoint(0.5, 0.5);
        }

        this.setCascadeOpacityEnabledRecursively(true);
        this.setRecCascadeColorEnabled(true);

        // TODO: track current animation
        this.runningAnimation = undefined;

        this.initialize();

        this.createSlots();

        if (cleverapps.config.debugMode && !cleverapps.config.editorMode && ["highstaging", "highstagingpng", "highlocal"].includes(cleverapps.resolution.resolutionName)) {
            this._checkProps();
        }
        if (cleverapps.Spine.debugSlots) {
            this.setDebugSlots(true);
        }
        if (cleverapps.Spine.debugBones) {
            this.setDebugBones(true);
        }
    },

    onExit: function () {
        this._super();

        if (this.externalAnimation) {
            this.externalAnimation.removeFromParent();
            this.externalAnimation = undefined;
        }
    },

    initialize: function () {
        this.setVisible(false);
        this.startVisibleListener = undefined;
    },

    getAnchorBone: function () {
        return this.getBone("anchor");
    },

    createSlots: function () {
        this.slots = {};

        this.data.bones.forEach(function (bone) {
            if (bone.name.startsWith("slot_")) {
                const node = new cc.Node();
                node.setAnchorPoint(0.5, 0.5);
                node.setContentSize(
                    bone.scaleX * resolutionScale || 0,
                    bone.scaleY * resolutionScale || 0
                );
                node.setAlignment(
                    this.width / 2 + (bone.x * resolutionScale || 0),
                    this.height / 2 + (bone.y * resolutionScale || 0)
                );
                node.setRotation(-bone.rotation);
                this.addChild(node);

                this.slots[bone.name] = node;

                if (cleverapps.config.debugMode) {
                    node._slotName = bone.name;

                    if (cleverapps.flags.debugBoneSlots) {
                        node.debugBorder({ permanent: true });
                    }
                }
            }
        }, this);

        if (cleverapps.config.debugMode) {
            // Every slot, not only the empty ones: a slot that holds something is exactly the one whose bounds are
            // worth seeing against what sits in it. debugBorder names each from _slotName, so the outlines are
            // readable rather than a heap of anonymous boxes.
            cleverapps.flags.on("change:debugBoneSlots", () => {
                for (const slot in this.slots) {
                    if (cleverapps.flags.debugBoneSlots) {
                        this.slots[slot].debugBorder({ permanent: true });
                    } else {
                        this.slots[slot].cleanupBorder({ permanent: true });
                    }
                }
            }, this);
        }
    },

    hasSlot: function (slot) {
        return this.slots[slot] !== undefined;
    },

    getSlot: function (slot) {
        if (cleverapps.config.debugMode) {
            if (this.slots[slot]) {
                this.slots[slot].cleanupBorder();
            } else {
                const info = cleverapps.Spine.getGitPath(this.jsonName);
                cleverapps.throwAsync(`No slot ${slot} in spine ${info.name} \n link: ${info.link}`);
            }
        }

        return this.slots[slot];
    },

    getBone: function (boneName) {
        return this.data.bones.find((bone) => bone.name === boneName);
    },

    setStartVisibleListener: function (listener) {
        this.startVisibleListener = listener;
    },

    setIdle: function (idleAnimation) {
        if (idleAnimation !== this.idle) {
            this.idle = idleAnimation;
            this.setAnimation(0, this.idle, true);
        }
    },

    setIdleSet: function (animations) {
        let sum = 0;
        Object.values(animations).forEach((prob) => {
            sum += prob;
        });
        const choose = function () {
            let number = Math.random() * sum;
            for (const key in animations) {
                number -= animations[key];
                if (number <= 0) {
                    return key;
                }
            }
        };

        const setAnimationAndChoose = () => {
            this.setAnimation(0, choose(), false);
            this.setCompleteListener(setAnimationAndChoose);
            this.setSafeToRemove();
        };

        setAnimationAndChoose();
    },

    hasAnimation: function (name) {
        return this.data.animations[name];
    },

    getAnimationData: function (name) {
        return this.spine.findAnimation(name);
    },

    getAnimationDuration: function (name) {
        const data = this.getAnimationData(name);
        if (data) {
            return data.duration;
        }
    },

    hasSkin: function (name) {
        return this.data.skins[name] !== undefined;
    },
    
    isExternal: function (name) {
        const data = this.data.animations[name];
        return data && data.bones && data.bones[`external_${name}`];
    },

    listAnimations: function () {
        return Object.keys(this.data.animations);
    },

    setAnimation: function (track, animation, repeat) {
        if (this.getCurrentAnimationName()) {
            this.setCompleteListener();
        }

        if (this.externalAnimation) {
            this.externalAnimation.removeFromParent();
            this.externalAnimation = undefined;
        }

        if (this.idle) {
            this.idle = undefined;
        }

        if (this.isExternal(animation)) {
            if (StandartAnimations[animation]) {
                this.externalAnimation = StandartAnimations[animation](this);
            } else {
                cleverapps.throwAsync(`Not found animation ${animation} in standart animations`);
            }
        } else {
            this.spine.setAnimation(track, animation, repeat);

            const json = this.spine.jsonName;
            if (!this.data.animations[animation]) {
                cleverapps.throwAsync(`Not found animation ${animation} in json ${json}`);
            }
        }

        if (!this.visible) {
            this.visible = true;
            this.startVisibleListener && this.startVisibleListener();
        }
    },

    createAction: function (animation, duration, callback) {
        return new cc.SpineAction(this, animation, duration, callback);
    },

    addAnimation: function (trackIndex, name, loop, delay) {
        if (this.externalAnimation) {
            this.externalAnimation.removeFromParent();
            this.externalAnimation = undefined;
        }

        this.spine.addAnimation(trackIndex, name, loop, delay);

        const json = this.spine.jsonName;
        if (!this.data.animations[name]) {
            cleverapps.throwAsync(`Not found animation ${name} in json ${json}`);
        }
    },

    getCurrentState: function (track) {
        return this.spine.getCurrent(track || 0);
    },

    getTimeLeft: function (track) {
        const state = this.getCurrentState(track);
        const duration = state && state.animation && state.animation.duration || 0;
        const trackTime = state && state.trackTime || 0;
        return Math.max(0, (duration - trackTime) / this.getTimeScale());
    },

    getCurrentAnimationName: function (track) {
        const state = this.spine.getCurrent(track);
        return state && state.animation && state.animation.name;
    },

    setTimeScale: function (scale) {
        this.spine.setTimeScale(scale);
    },

    getTimeScale: function () {
        return this.spine.getTimeScale();
    },

    clearTrack: function (trackIndex) {
        if (this.externalAnimation) {
            this.externalAnimation.removeFromParent();
            this.externalAnimation = undefined;
        } else {
            this.spine.clearTrack(trackIndex);
        }
    },

    setAnimationFrame: function (track, frame) {
        const state = this.getCurrentState(track);
        if (!state) {
            return;
        }

        state.trackTime = frame / (this.data.skeleton.fps || 30);
        this.spine.update(0);
    },

    setSkin: function (skin) {
        this.spine.setSkin(skin);
    },

    getSkin: function () {
        const skin = this.spine._skeleton && this.spine._skeleton.skin;
        return skin && skin.name !== "default" ? skin.name : undefined;
    },

    setTrackProgress: function (normalizedProgress) {
        const state = this.getCurrentState(0);
        if (state) {
            state.trackTime = normalizedProgress * state.animationEnd;
        }
    },

    playReverse: function (track, animation, timeScale) {
        if (this._reverseTick) {
            this.unschedule(this._reverseTick);
            this._reverseTick = undefined;
        }

        this.setAnimation(track, animation, false);
        this.setTrackProgress(1);

        const scale = Math.abs(timeScale || 1);

        const startState = this.getCurrentState(track);
        if (!startState) {
            return;
        }

        startState.timeScale = 0;

        this._reverseTick = (dt) => {
            const cur = this.getCurrentState(track);
            if (cur !== startState || !cur.animation || cur.animation.name !== animation) {
                this.unschedule(this._reverseTick);
                this._reverseTick = undefined;
                return;
            }
            cur.trackTime = Math.max(0, cur.trackTime - scale * dt);
            if (cur.trackTime <= 0) {
                this.unschedule(this._reverseTick);
                this._reverseTick = undefined;
            }
        };
        this.schedule(this._reverseTick);
    },

    setStartListener: function (callback) {
        this.spine.setStartListener(callback);
    },

    setCompleteListener: function (callback) {
        this.spine.setCompleteListener(callback || (() => {}));

        this._cantBeRemoved = Boolean(callback);

        if (this.saveStack && this._cantBeRemoved) {
            this.actionStack = new Error().stack;
        }
    },

    setCompleteListenerRemove: function (callback) {
        this.setCompleteListener(() => {
            if (callback) {
                callback();
            }
            this.runAction(new cc.RemoveSelf());
        });
        this.setSafeToRemove();
    },

    setCompleteListenerOnce: function (listener) {
        this.setCompleteListener(() => {
            listener();
            this.setCompleteListener();
        });
    },

    setAnimationAndIdleAfter: function (animation, idle) {
        this.setAnimation(0, animation, false);
        this.addAnimation(0, idle, true);
    },

    setDebugSlots: function (enable) {
        this.spine.setDebugSolots(enable);
    },

    setDebugBones: function (enable) {
        this.spine.setDebugBones(enable);
    },

    setMix: function (fromAnimation, toAnimation, duration) {
        const stateData = this.spine._state && this.spine._state.data;
        if (stateData) {
            stateData.setMix(fromAnimation, toAnimation, duration);
        }
    },

    _checkProps: function () {
        if (!cleverapps.UI.ImageFont.IsApplicable(cleverapps.styles.FONTS.WHITE_TEXT, "*")) {
            return;
        }

        const marks = [];
        const root = this.data.bones[0];
        let color;

        if (root.scaleX && root.scaleX !== 1 || root.scaleY && root.scaleY !== 1) {
            const dX = root.scaleX ? Math.abs(1 - Math.abs(root.scaleX)) : 0;
            const dY = root.scaleY ? Math.abs(1 - Math.abs(root.scaleY)) : 0;
            const value = Math.max(dX, dY);

            color = cleverapps.styles.COLORS.YELLOW;
            if (value >= 0.25) {
                color = cleverapps.styles.COLORS.COLOR_RED;
            } else if (value > 0.1) {
                color = cleverapps.styles.COLORS.ORANGE;
            }

            const scaleMark = new cc.Sprite(bundles.spine_marks.frames.scale_mark);
            scaleMark.setColor(color);
            marks.push(scaleMark);
        }

        let verts = 0;
        for (const skin in this.data.skins) {
            let skinVerts = 0;
            for (const bone in this.data.skins[skin]) {
                for (const img in this.data.skins[skin][bone]) {
                    const attachment = this.data.skins[skin][bone][img];
                    if (attachment.uvs) {
                        skinVerts += attachment.uvs.length / 2;
                    }
                }
            }
            if (skinVerts > verts) {
                verts = skinVerts;
            }
        }
        this._verts = verts;
        if (verts >= 400) {
            const vertsMark = new cc.Sprite(bundles.spine_marks.frames.verts_mark);
            marks.push(vertsMark);

            color = cc.color(255, 0, 0);
            if (verts < 2500) {
                const mapToColor = function (value, inMin, inMax, outMin, outMax) {
                    return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
                };
                const r = mapToColor(verts, 400, 2500, 70, 255);
                const b = mapToColor(verts, 400, 2500, 63, 74);
                const g = mapToColor(verts, 400, 2500, 255, 74);
                color = cc.color(r, g, b);
            }
            vertsMark.setColor(color);
        }

        if (marks.length > 0) {
            const marksNode = new cleverapps.Layout(marks, { direction: cleverapps.UI.VERTICAL });
            marksNode.setPosition(this.width, this.height);
            this.addChild(marksNode);
            cleverapps.UI.onClick(marksNode, () => {
                cleverapps.sceneDebugger.selectNode(this);
            });
        }
    },

    setSafeToRemove: function () {
        this._cantBeRemoved = false;
        delete this.actionStack;
    },

    isSaveToRemove: function () {
        return !this._cantBeRemoved;
    },

    getCurSkin: function () {
        if (!this.spine._skeleton.skin) {
            return "default";
        }
        return this.spine._skeleton.skin.name;
    },

    getBoundingBoxToWorld: function () {
        const rect = cc.rect(0, 0, this._contentSize.width, this._contentSize.height);
        const trans = this.getNodeToWorldTransform();
        return cc.rectApplyAffineTransform(rect, trans);
    },

    _getBoundingBoxToCurrentNode: function (parentTransform) {
        const rect = cc.rect(0, 0, this._contentSize.width, this._contentSize.height);
        const trans = (parentTransform === undefined) ? this.getNodeToParentTransform() : cc.affineTransformConcat(this.getNodeToParentTransform(), parentTransform);
        return cc.rectApplyAffineTransform(rect, trans);
    },

    unuse: function () {
        this.removeTemporarily(false);

        this.setStartListener(undefined);
        this.setCompleteListener(undefined);
        this.clearTrack(0);
    },

    reuse: function () {
        this.initialize();
    },

    getSkeletonData: function () {
        return cc.loader.getRes(this.jsonName);
    },

    listSkins: function () {
        const data = this.getSkeletonData();

        return Object.keys(data.skins).filter((name) => name !== "default");
    },

    visitTextureBundle: function () {
        if (this.jsonName instanceof VirtualJson) {
            cc.rendererBundle = this.jsonName.bundleName;
        }
    }
});

cleverapps.Spine.getCachedData = function (json) {
    if (json instanceof VirtualJson) {
        return json.getCachedData();
    }
};

cleverapps.Spine.setCachedData = function (data, json) {
    if (json instanceof VirtualJson) {
        json.setCachedData(data);
    }
};

cleverapps.Spine.unloadCachedData = function () {
};

cleverapps.Spine.processJson = function (json) {
    json = cleverapps.skins.getSlot("spine", {
        json
    });
    return json instanceof VirtualJson ? json.resolve() : json;
};

cleverapps.Spine.hasAnimation = function (name, json) {
    const data = cleverapps.Spine.getSkeletonData(json);
    return data && data.animations && data.animations[name] !== undefined;
};

cleverapps.Spine.hasSkin = function (name, json) {
    const data = cleverapps.Spine.getSkeletonData(json);
    return data && data.skins && data.skins[name] !== undefined;
};

cleverapps.Spine.getSkeletonData = function (json) {
    return cc.loader.getRes(json.resolve());
};

cleverapps.Spine.isAnimationLoaded = function (json) {
    if (json instanceof VirtualJson) {
        json = cleverapps.skins.getSlot("spine", { json }).resolve();
        return cleverapps.bundleLoader.isLoaded(json.bundleName);
    }
};

cleverapps.Spine.removeSlot = function (json, toRemove) {
    json = json.resolve();
    json = cleverapps.skins.getSlot("spine", {
        json
    });
    json = cc.loader.getRes(json);

    json.slots = json.slots.filter((slot) => slot.name !== toRemove);

    Object.values(json.skins).forEach((skin) => {
        delete skin[toRemove];
    });

    Object.values(json.animations).forEach((animation) => {
        delete animation.slots[toRemove];
    });
};

cleverapps.Spine.getGitPath = function (json) {
    let originalPath;

    if (json instanceof VirtualResource) {
        originalPath = json.resolve().originalPath();
    }

    if (originalPath) {
        let repoInd = originalPath.indexOf("/");
        let repoName = originalPath.substring(0, repoInd);
        if (repoName === "res") {
            repoName = cleverapps.config.name;
            repoInd = -1;
        }
        const link = `https://github.com/Clever-Apps-Pte-Ltd/${repoName}/tree/master/${originalPath.substring(repoInd + 1, originalPath.lastIndexOf("/"))}`;
        return {
            name: json.toString(),
            link
        };
    }
};

cleverapps.Spine.cache = {};

cleverapps.Spine.GetPoolId = function (obj) {
    if (obj instanceof cleverapps.Spine) {
        obj = obj.jsonName;
    }
    return `spine_${obj}`;
};

cleverapps.Spine.GetFromPool = function (json) {
    json = json instanceof VirtualJson ? json.resolve() : json;

    return cleverapps.pool.getFromPool(cleverapps.Spine, json) || new cleverapps.Spine(json);
};

// cleverapps.Spine.debugSlots = true;
